import { useEffect, useState } from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { api } from "@/lib/api";

export const F = ({ label, value, onChange, type = "text", testid, area, className = "" }) => (
  <div className={className}>
    <Label className="text-xs">{label}</Label>
    {area ? <Textarea data-testid={testid} rows={2} value={value ?? ""} onChange={(e) => onChange(e.target.value)} />
      : <Input data-testid={testid} type={type} value={value ?? ""} onChange={(e) => onChange(e.target.value)} />}
  </div>
);

export const Section = ({ title, children }) => (
  <fieldset className="rounded-lg border border-slate-200 p-3 space-y-3">
    <legend className="px-1 text-xs font-semibold uppercase tracking-wider text-slate-500">{title}</legend>
    {children}
  </fieldset>
);

export const PartyFields = ({ value = {}, onChange, prefix, extra }) => {
  const set = (k) => (v) => onChange({ ...value, [k]: v });
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
      <F label="TC Kimlik No" testid={`${prefix}-tc`} value={value.tc} onChange={set("tc")} />
      <F label="Adı Soyadı / Ünvanı" testid={`${prefix}-name`} value={value.name} onChange={set("name")} />
      <F label="Telefon" testid={`${prefix}-phone`} value={value.phone} onChange={set("phone")} />
      {extra}
      <F label="Adres" className="col-span-2 md:col-span-4" testid={`${prefix}-address`} value={value.address} onChange={set("address")} />
    </div>
  );
};

export const PickSelect = ({ url, label, placeholder, toLabel, onPick, testid }) => {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get(url).then((r) => setItems(r.data)).catch(() => {}); }, [url]);
  return (
    <div>
      <Label className="text-xs">{label}</Label>
      <Select value="" onValueChange={(id) => onPick(items.find((x) => x.id === id))}>
        <SelectTrigger data-testid={testid}><SelectValue placeholder={placeholder} /></SelectTrigger>
        <SelectContent className="max-h-64">{items.map((x) => <SelectItem key={x.id} value={x.id}>{toLabel(x)}</SelectItem>)}</SelectContent>
      </Select>
    </div>
  );
};
